export class Tham {
  constructor()
  {
    this.tham = document.querySelector('.js-tham')
    this.subscribers = [];
    this.header_menu_elements = document.querySelectorAll('.js-header-menu a[href^="#"]');
    this.open = false;
    this.init();
  }

  init()
  {
    if (!this.tham) {
      return false;
    }

    this.addListener();

  }

  addListener()
  {
    this.tham.addEventListener('click', () => {
      this.toogleThamState();

      this.open = !this.open;

      this.subscribers.forEach(s => {
        s(this.open);
      })

    })
  }

  toogleThamState()
  {
    const is_open = this.tham.classList.contains('tham-active');

    if (is_open) {
      this.tham.setAttribute('aria-expanded', 'false');
    } else {
      this.tham.setAttribute('aria-expanded', 'true');
    }

    this.tham.classList.toggle('tham-active');
  }

  subscribe(subscriber)
  {
    this.subscribers.push(subscriber)
  }
}
